import{a as P}from"./ids-chunk-3W4P7KSD.js";import{a as L}from"./ids-chunk-2OQEBFK3.js";import{a as l,b as v,c as h,d as m,e as B,f,g as D}from"./ids-chunk-OGHHTH6V.js";import{a as O}from"./ids-chunk-776GZ2XO.js";import{a as C}from"./ids-chunk-VEO6QETS.js";import{a as T}from"./ids-chunk-U4K5B3VN.js";import{a as S}from"./ids-chunk-6QMEC4B7.js";import{a as I,b as E}from"./ids-chunk-XE4WFW5M.js";import{a as N}from"./ids-chunk-W3LDHTW6.js";import{e as a}from"./ids-chunk-Y6KVKFJX.js";import{a as o,b as A}from"./ids-chunk-TFRXZ5TN.js";import{a as y,b as g,c as x,d as k,e as w,f as c}from"./ids-chunk-ZMMCFAAI.js";var _=`/**
 * Ids Button Component CSS
 * (Includes standard and icon button rules)
 */
/**
 * Ids Button Sass mixins, used in Ids Button CSS to define base styles.
 */
/**
 * Provides standardized padding rules for certain button types
 */
/**
 * Provides the standard color rules for all regular buttons
 */
/**
 * Provides the standard color rules for buttons that need box shadow
 */
:host {
  display: inline-flex;
  vertical-align: middle;
}
:host ::slotted(span) {
  vertical-align: bottom;
}
:host ::slotted(span),
:host ::slotted(ids-text) {
  color: currentColor;
  align-self: center;
}
:host ::slotted(ids-icon) {
  vertical-align: middle;
  color: currentColor;
}
:host ::slotted(span.audible) {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
:host button,
:host .ids-icon-button {
  justify-content: center;
  height: 100%;
  width: 100%;
}

:host(.hidden) {
  display: none;
}

:host([system-button]) button:hover {
  background-color: var(--ids-color-transparent);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-system-color-text-hover);
}

:host([hidden]) {
  display: none;
}

button {
  display: block;
}

.ids-button,
.ids-toggle-button,
.ids-menu-button:not(.ids-icon-button),
.ids-modal-button {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ids-button .ids-icon,
.ids-toggle-button .ids-icon,
.ids-menu-button:not(.ids-icon-button) .ids-icon,
.ids-modal-button .ids-icon {
  display: inline-flex;
  place-self: center;
  vertical-align: middle;
}

.ids-button,
.ids-toggle-button,
.ids-menu-button {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
  display: inline-flex;
  font-weight: var(--ids-button-tertiary-font-weight);
  border-radius: var(--ids-button-radius);
  background-color: var(--ids-button-tertiary-color-background-default);
  border-color: var(--ids-button-tertiary-color-border-default);
  color: var(--ids-button-tertiary-color-text-default);
}
.ids-button, .ids-button::before, .ids-button::after,
.ids-toggle-button,
.ids-toggle-button::before,
.ids-toggle-button::after,
.ids-menu-button,
.ids-menu-button::before,
.ids-menu-button::after {
  box-sizing: border-box;
}
.ids-button *,
.ids-toggle-button *,
.ids-menu-button * {
  pointer-events: none;
}
.ids-button:focus,
.ids-toggle-button:focus,
.ids-menu-button:focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-button:not([disabled]),
.ids-toggle-button:not([disabled]),
.ids-menu-button:not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-button span,
.ids-toggle-button span,
.ids-menu-button span {
  vertical-align: bottom;
}
.ids-button span.audible,
.ids-toggle-button span.audible,
.ids-menu-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-button:not(.ids-icon-button):not(.align-icon-end) ::slotted(ids-icon:not([icon=insights-smart-panel])),
.ids-toggle-button:not(.ids-icon-button):not(.align-icon-end) ::slotted(ids-icon:not([icon=insights-smart-panel])),
.ids-menu-button:not(.ids-icon-button):not(.align-icon-end) ::slotted(ids-icon:not([icon=insights-smart-panel])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-button .ids-icon,
.ids-toggle-button .ids-icon,
.ids-menu-button .ids-icon {
  vertical-align: middle;
}
.ids-button.align-icon-end ::slotted(ids-icon),
.ids-toggle-button.align-icon-end ::slotted(ids-icon),
.ids-menu-button.align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-button.content-align-start,
.ids-toggle-button.content-align-start,
.ids-menu-button.content-align-start {
  justify-content: start;
}
.ids-button.content-align-end,
.ids-toggle-button.content-align-end,
.ids-menu-button.content-align-end {
  justify-content: end;
}
.ids-button.no-margins,
.ids-toggle-button.no-margins,
.ids-menu-button.no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-button.field-height-xxs:not(.btn-secondary):not(.no-margins),
.ids-toggle-button.field-height-xxs:not(.btn-secondary):not(.no-margins),
.ids-menu-button.field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-button ::slotted(span),
.ids-toggle-button ::slotted(span),
.ids-menu-button ::slotted(span) {
  font-weight: inherit !important;
}
.ids-button:not(.hide-focus).is-active:not([readonly]), .ids-button:not(.hide-focus).is-focused:not([readonly]), .ids-button:not(.hide-focus):focus:not([readonly]), .ids-button:not(.hide-focus):focus-within:not([readonly]),
.ids-toggle-button:not(.hide-focus).is-active:not([readonly]),
.ids-toggle-button:not(.hide-focus).is-focused:not([readonly]),
.ids-toggle-button:not(.hide-focus):focus:not([readonly]),
.ids-toggle-button:not(.hide-focus):focus-within:not([readonly]),
.ids-menu-button:not(.hide-focus).is-active:not([readonly]),
.ids-menu-button:not(.hide-focus).is-focused:not([readonly]),
.ids-menu-button:not(.hide-focus):focus:not([readonly]),
.ids-menu-button:not(.hide-focus):focus-within:not([readonly]) {
  border-color: var(--ids-button-tertiary-color-border-focus);
}
.ids-button:hover,
.ids-toggle-button:hover,
.ids-menu-button:hover {
  color: var(--ids-button-tertiary-color-text-hover);
  background-color: var(--ids-button-tertiary-color-background-hover);
  border-color: var(--ids-button-tertiary-color-border-hover);
}
.ids-button[disabled],
.ids-toggle-button[disabled],
.ids-menu-button[disabled] {
  color: var(--ids-button-tertiary-color-text-disabled);
  background-color: var(--ids-button-tertiary-color-background-disabled);
  border-color: var(--ids-button-tertiary-color-border-disabled);
  opacity: var(--ids-button-tertiary-opacity-disabled);
}
.ids-button:active:not([disabled]),
.ids-toggle-button:active:not([disabled]),
.ids-menu-button:active:not([disabled]) {
  background-color: var(--ids-button-tertiary-color-background-pressed);
  border-color: var(--ids-button-tertiary-color-border-pressed);
  color: var(--ids-button-tertiary-color-text-pressed);
}
.ids-button.btn-tertiary-destructive,
.ids-toggle-button.btn-tertiary-destructive,
.ids-menu-button.btn-tertiary-destructive {
  background-color: var(--ids-button-destructive-tertiary-color-background-default);
  border-color: var(--ids-button-destructive-tertiary-color-border-default);
  color: var(--ids-button-destructive-tertiary-color-text-default);
}
.ids-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-tertiary-color-border-focus);
}
.ids-button.btn-tertiary-destructive:hover,
.ids-toggle-button.btn-tertiary-destructive:hover,
.ids-menu-button.btn-tertiary-destructive:hover {
  background-color: var(--ids-button-destructive-tertiary-color-background-hover);
  border-color: var(--ids-button-destructive-tertiary-color-border-hover);
  color: var(--ids-button-destructive-tertiary-color-text-hover);
}
.ids-button.btn-tertiary-destructive[disabled],
.ids-toggle-button.btn-tertiary-destructive[disabled],
.ids-menu-button.btn-tertiary-destructive[disabled] {
  color: var(--ids-button-destructive-tertiary-color-text-disabled);
  background-color: var(--ids-button-destructive-tertiary-color-background-disabled);
  border-color: var(--ids-button-destructive-tertiary-color-border-disabled);
}
.ids-button.btn-primary,
.ids-toggle-button.btn-primary,
.ids-menu-button.btn-primary {
  background-color: var(--ids-button-primary-color-background-default);
  border-color: var(--ids-button-primary-color-border-default);
  border: 1px solid var(--ids-button-primary-color-border-default);
  color: var(--ids-button-primary-color-text-default);
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
}
.ids-button.btn-primary:not(.hide-focus).is-active, .ids-button.btn-primary:not(.hide-focus).is-focused, .ids-button.btn-primary:not(.hide-focus).focus-within, .ids-button.btn-primary:not(.hide-focus):focus,
.ids-toggle-button.btn-primary:not(.hide-focus).is-active,
.ids-toggle-button.btn-primary:not(.hide-focus).is-focused,
.ids-toggle-button.btn-primary:not(.hide-focus).focus-within,
.ids-toggle-button.btn-primary:not(.hide-focus):focus,
.ids-menu-button.btn-primary:not(.hide-focus).is-active,
.ids-menu-button.btn-primary:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary:not(.hide-focus):focus {
  border-color: var(--ids-button-primary-color-border-focus);
}
.ids-button.btn-primary:hover,
.ids-toggle-button.btn-primary:hover,
.ids-menu-button.btn-primary:hover {
  background-color: var(--ids-button-primary-color-background-hover);
  border-color: var(--ids-button-primary-color-border-hover);
}
.ids-button.btn-primary[disabled],
.ids-toggle-button.btn-primary[disabled],
.ids-menu-button.btn-primary[disabled] {
  background-color: var(--ids-button-primary-color-background-disabled);
  border-color: var(--ids-button-primary-color-border-disabled);
  color: var(--ids-button-primary-color-text-disabled);
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-button.btn-primary:active:not([disabled]),
.ids-toggle-button.btn-primary:active:not([disabled]),
.ids-menu-button.btn-primary:active:not([disabled]) {
  background-color: var(--ids-button-primary-color-background-pressed);
  border-color: var(--ids-button-primary-color-border-pressed);
  color: var(--ids-button-primary-color-text-pressed);
}
.ids-button.btn-primary-destructive,
.ids-toggle-button.btn-primary-destructive,
.ids-menu-button.btn-primary-destructive {
  background-color: var(--ids-button-destructive-color-background-default);
  border-color: var(--ids-button-destructive-color-border-default);
  color: var(--ids-button-destructive-color-text-default);
}
.ids-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-color-border-focus);
}
.ids-button.btn-primary-destructive:hover,
.ids-toggle-button.btn-primary-destructive:hover,
.ids-menu-button.btn-primary-destructive:hover {
  background-color: var(--ids-button-destructive-color-background-hover);
  border-color: var(--ids-button-destructive-color-border-hover);
  color: var(--ids-button-destructive-color-text-hover);
}
.ids-button.btn-primary-destructive[disabled],
.ids-toggle-button.btn-primary-destructive[disabled],
.ids-menu-button.btn-primary-destructive[disabled] {
  background-color: var(--ids-button-destructive-color-background-disabled);
  border-color: var(--ids-button-destructive-color-border-disabled);
  color: var(--ids-button-destructive-color-text-disabled);
  opacity: var(--ids-button-destructive-opacity-disabled);
}
@keyframes dot-flashing {
  0% {
    background-color: #fff;
  }
  50%, 100% {
    background-color: rgba(255 255 255/var(--ids-opacity-disabled));
  }
}
@keyframes dot-flashing-colors {
  0% {
    background-color: #0B9789;
  }
  50%, 100% {
    background-color: #1A3362;
  }
}
.ids-button .loading-dots,
.ids-toggle-button .loading-dots,
.ids-menu-button .loading-dots {
  display: none;
  position: relative;
  flex-direction: row;
  gap: 2px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
}
.ids-button .loading-dots .dot,
.ids-toggle-button .loading-dots .dot,
.ids-menu-button .loading-dots .dot {
  display: inline-flex;
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: var(--ids-button-ai-color-loading-dot-default);
  color: var(--ids-button-ai-color-loading-dot-default);
}
.ids-button.btn-primary-generative-ai,
.ids-toggle-button.btn-primary-generative-ai,
.ids-menu-button.btn-primary-generative-ai {
  background: border-box var(--ids-button-ai-color-background-default);
  color: #FFF;
  align-items: center;
  min-width: 34px;
  min-height: 34px;
}
.ids-button.btn-primary-generative-ai:hover,
.ids-toggle-button.btn-primary-generative-ai:hover,
.ids-menu-button.btn-primary-generative-ai:hover {
  background: border-box var(--ids-button-ai-color-background-hover);
  border-color: var(--ids-button-ai-color-border-hover);
}
.ids-button.btn-primary-generative-ai:active, .ids-button.btn-primary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-primary-generative-ai:active,
.ids-toggle-button.btn-primary-generative-ai.gen-ai-active,
.ids-menu-button.btn-primary-generative-ai:active,
.ids-menu-button.btn-primary-generative-ai.gen-ai-active {
  background: border-box var(--ids-button-ai-color-background-active);
  color: var(--ids-button-ai-color-text-active);
}
.ids-button.btn-primary-generative-ai[disabled],
.ids-toggle-button.btn-primary-generative-ai[disabled],
.ids-menu-button.btn-primary-generative-ai[disabled] {
  background: border-box var(--ids-button-ai-color-background-disabled);
  border-color: var(--ids-button-ai-color-background-color-disabled);
}
.ids-button.btn-primary-generative-ai.color-variant-alternate-formatter, .ids-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover,
.ids-toggle-button.btn-primary-generative-ai.color-variant-alternate-formatter,
.ids-toggle-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover,
.ids-menu-button.btn-primary-generative-ai.color-variant-alternate-formatter,
.ids-menu-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover {
  color: #FFF;
  min-height: var(--ids-button-formatter-size);
  min-width: 34px;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-tertiary-generative-ai,
.ids-toggle-button.btn-tertiary-generative-ai,
.ids-menu-button.btn-tertiary-generative-ai {
  background: var(--ids-button-ai-color-tertiary-background-default);
  background-clip: text;
  -webkit-text-fill-color: var(--ids-color-transparent);
  align-items: center;
}
.ids-button.btn-tertiary-generative-ai:hover,
.ids-toggle-button.btn-tertiary-generative-ai:hover,
.ids-menu-button.btn-tertiary-generative-ai:hover {
  background: var(--ids-button-ai-color-tertiary-background-hover);
  background-clip: text;
  border-color: var(--ids-color-transparent);
  -webkit-text-fill-color: var(--ids-color-transparent);
}
.ids-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=insights-smart-panel]),
.ids-toggle-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=insights-smart-panel]),
.ids-menu-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=insights-smart-panel]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);
}
.ids-button.btn-tertiary-generative-ai:active .ids-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-button.btn-tertiary-generative-ai:active .ids-toggle-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-button.btn-tertiary-generative-ai:active .ids-menu-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-tertiary-generative-ai:active .ids-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-tertiary-generative-ai:active .ids-toggle-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-tertiary-generative-ai:active .ids-menu-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-menu-button.btn-tertiary-generative-ai:active .ids-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-menu-button.btn-tertiary-generative-ai:active .ids-toggle-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-menu-button.btn-tertiary-generative-ai:active .ids-menu-button.btn-tertiary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-color-background-active);
  background-clip: text;
  -webkit-text-fill-color: var(--ids-color-transparent);
}
.ids-button.btn-tertiary-generative-ai[disabled],
.ids-toggle-button.btn-tertiary-generative-ai[disabled],
.ids-menu-button.btn-tertiary-generative-ai[disabled] {
  background: var(--ids-button-tertiary-ai-color-background-disabled);
  background-clip: text;
  -webkit-text-fill-color: var(--ids-color-transparent);
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-button.btn-tertiary-generative-ai[disabled] ::slotted(ids-icon[icon=insights-smart-panel]),
.ids-toggle-button.btn-tertiary-generative-ai[disabled] ::slotted(ids-icon[icon=insights-smart-panel]),
.ids-menu-button.btn-tertiary-generative-ai[disabled] ::slotted(ids-icon[icon=insights-smart-panel]) {
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-secondary,
.ids-toggle-button.btn-secondary,
.ids-menu-button.btn-secondary {
  background-color: var(--ids-button-secondary-color-background-default);
  border-width: var(--ids-button-secondary-border-width);
  border-color: var(--ids-button-secondary-color-border-default);
  color: var(--ids-button-secondary-color-text-default);
}
.ids-button.btn-secondary:not(.hide-focus).is-active, .ids-button.btn-secondary:not(.hide-focus).is-focused, .ids-button.btn-secondary:not(.hide-focus).focus-within, .ids-button.btn-secondary:not(.hide-focus):focus,
.ids-toggle-button.btn-secondary:not(.hide-focus).is-active,
.ids-toggle-button.btn-secondary:not(.hide-focus).is-focused,
.ids-toggle-button.btn-secondary:not(.hide-focus).focus-within,
.ids-toggle-button.btn-secondary:not(.hide-focus):focus,
.ids-menu-button.btn-secondary:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary:not(.hide-focus):focus {
  background-color: var(--ids-button-secondary-color-background-focus);
  border-color: var(--ids-button-secondary-color-border-focus);
}
.ids-button.btn-secondary:hover:not([disabled]),
.ids-toggle-button.btn-secondary:hover:not([disabled]),
.ids-menu-button.btn-secondary:hover:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-hover);
  border-color: var(--ids-button-secondary-color-border-hover);
  color: var(--ids-button-secondary-color-text-hover);
}
.ids-button.btn-secondary[disabled],
.ids-toggle-button.btn-secondary[disabled],
.ids-menu-button.btn-secondary[disabled] {
  background-color: var(--ids-button-secondary-color-background-disabled);
  border-color: var(--ids-button-secondary-color-border-disabled);
  color: var(--ids-button-secondary-color-text-disabled);
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-button.btn-secondary:active:not([disabled]),
.ids-toggle-button.btn-secondary:active:not([disabled]),
.ids-menu-button.btn-secondary:active:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-pressed);
  border-color: var(--ids-button-secondary-color-border-pressed);
  color: var(--ids-button-secondary-color-text-pressed);
}
.ids-button.color-variant-alternate:hover,
.ids-toggle-button.color-variant-alternate:hover,
.ids-menu-button.color-variant-alternate:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.ids-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover,
.ids-toggle-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover,
.ids-menu-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover {
  background-color: var(--ids-search-field-header-color-icon-hover);
}
.ids-button.color-variant-app-menu:hover,
.ids-toggle-button.color-variant-app-menu:hover,
.ids-menu-button.color-variant-app-menu:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.ids-button.color-variant-alternate, .ids-button.color-variant-alternate-formatter,
.ids-toggle-button.color-variant-alternate,
.ids-toggle-button.color-variant-alternate-formatter,
.ids-menu-button.color-variant-alternate,
.ids-menu-button.color-variant-alternate-formatter {
  color: var(--ids-button-alternate-color-text-default);
  opacity: 0.8;
}
.ids-button.color-variant-alternate:not(.hide-focus).is-active, .ids-button.color-variant-alternate:not(.hide-focus).is-focused, .ids-button.color-variant-alternate:not(.hide-focus).focus-within, .ids-button.color-variant-alternate:not(.hide-focus):focus, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-button-formatter-color-border-focus);
  opacity: 1;
}
.ids-button.color-variant-alternate:hover, .ids-button.color-variant-alternate-formatter:hover,
.ids-toggle-button.color-variant-alternate:hover,
.ids-toggle-button.color-variant-alternate-formatter:hover,
.ids-menu-button.color-variant-alternate:hover,
.ids-menu-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-formatter-color-text-hover);
  opacity: 1;
}
.ids-button.color-variant-alternate[disabled], .ids-button.color-variant-alternate-formatter[disabled],
.ids-toggle-button.color-variant-alternate[disabled],
.ids-toggle-button.color-variant-alternate-formatter[disabled],
.ids-menu-button.color-variant-alternate[disabled],
.ids-menu-button.color-variant-alternate-formatter[disabled] {
  background-color: var(--ids-color-transparent);
  opacity: var(--ids-button-formatter-opacity-disabled);
}
.ids-button.color-variant-alternate-formatter,
.ids-toggle-button.color-variant-alternate-formatter,
.ids-menu-button.color-variant-alternate-formatter {
  background-color: var(--ids-button-formatter-color-background-default);
  border-color: var(--ids-button-formatter-color-border-default);
  color: var(--ids-button-formatter-color-text-default);
  margin-top: 2px;
  height: var(--ids-button-formatter-size);
  min-width: var(--ids-button-formatter-size);
}
.ids-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-color-border-focus);
}
.ids-button.color-variant-alternate-formatter[disabled],
.ids-toggle-button.color-variant-alternate-formatter[disabled],
.ids-menu-button.color-variant-alternate-formatter[disabled] {
  color: var(--ids-button-formatter-color-text-disabled);
}
.ids-button.color-variant-alternate-formatter:hover,
.ids-toggle-button.color-variant-alternate-formatter:hover,
.ids-menu-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  color: var(--ids-button-formatter-color-text-hover);
}
.ids-button.color-variant-alternate-formatter.is-active,
.ids-toggle-button.color-variant-alternate-formatter.is-active,
.ids-menu-button.color-variant-alternate-formatter.is-active {
  color: var(--ids-button-formatter-color-active);
}
.ids-button.color-variant-alternate-formatter.ids-menu-button.compact,
.ids-toggle-button.color-variant-alternate-formatter.ids-menu-button.compact,
.ids-menu-button.color-variant-alternate-formatter.ids-menu-button.compact {
  padding: var(--ids-space-2xs);
  padding-inline: var(--ids-space-2xs);
}
.ids-button.color-variant-alternate-formatter.ids-menu-button.compact.square,
.ids-toggle-button.color-variant-alternate-formatter.ids-menu-button.compact.square,
.ids-menu-button.color-variant-alternate-formatter.ids-menu-button.compact.square {
  border-radius: var(--ids-border-radius-xs);
}
.ids-button.color-variant-alternate-formatter[editor-action=sourcemode], .ids-button.color-variant-alternate-formatter[editor-action=editormode],
.ids-toggle-button.color-variant-alternate-formatter[editor-action=sourcemode],
.ids-toggle-button.color-variant-alternate-formatter[editor-action=editormode],
.ids-menu-button.color-variant-alternate-formatter[editor-action=sourcemode],
.ids-menu-button.color-variant-alternate-formatter[editor-action=editormode] {
  --ids-button-icon-width: 54px;
}
.ids-button.color-variant-module,
.ids-toggle-button.color-variant-module,
.ids-menu-button.color-variant-module {
  color: var(--ids-button-module-color-text-default);
}
.ids-button.color-variant-module:not(.square),
.ids-toggle-button.color-variant-module:not(.square),
.ids-menu-button.color-variant-module:not(.square) {
  border-radius: var(--ids-button-module-border-radius);
}
.ids-button.color-variant-module:hover,
.ids-toggle-button.color-variant-module:hover,
.ids-menu-button.color-variant-module:hover {
  background-color: var(--ids-button-module-color-background-hover);
  color: var(--ids-button-module-color-text-hover);
}
.ids-button:not(.no-padding),
.ids-toggle-button:not(.no-padding),
.ids-menu-button:not(.no-padding) {
  padding-inline: var(--ids-button-padding-inline);
}
.ids-button.btn-tertiary, .ids-button.btn-tertiary-destructive,
.ids-toggle-button.btn-tertiary,
.ids-toggle-button.btn-tertiary-destructive,
.ids-menu-button.btn-tertiary,
.ids-menu-button.btn-tertiary-destructive {
  padding-inline: var(--ids-space-12);
}
.ids-button.no-padding,
.ids-toggle-button.no-padding,
.ids-menu-button.no-padding {
  padding-inline: var(--ids-space-12);
}

.ids-menu-button.is-active,
.ids-menu-button.is-active:hover {
  background-color: var(--ids-button-menu-background-color-active);
  color: var(--ids-button-menu-color-text-active);
}

.ids-menu-button.formatter-width:not(.no-padding):not(.ids-icon-button) {
  padding-inline-start: calc(var(--ids-space-xs) - 1px);
  padding-inline-end: calc(var(--ids-space-xs) - 1px);
}
.ids-menu-button.formatter-width:not(.formatter-width-percentage) {
  justify-content: normal;
}
.ids-menu-button.formatter-width:not(.formatter-width-percentage) .ids-icon {
  position: absolute;
  inset-inline-end: var(--ids-space-2xs);
}

.ids-icon-button {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
  display: inline-flex;
  font-weight: var(--ids-button-tertiary-font-weight);
  border-radius: var(--ids-button-radius);
  background-color: var(--ids-button-tertiary-color-background-default);
  border-color: var(--ids-button-tertiary-color-border-default);
  color: var(--ids-button-tertiary-color-text-default);
  padding-inline-start: var(--ids-button-icon-padding);
  padding-inline-end: var(--ids-button-icon-padding);
  padding-block-start: var(--ids-button-icon-padding);
  padding-block-end: var(--ids-button-icon-padding);
}
.ids-icon-button, .ids-icon-button::before, .ids-icon-button::after {
  box-sizing: border-box;
}
.ids-icon-button * {
  pointer-events: none;
}
.ids-icon-button:focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-icon-button:not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-icon-button span {
  vertical-align: bottom;
}
.ids-icon-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-icon-button:not(.ids-icon-button):not(.align-icon-end) ::slotted(ids-icon:not([icon=insights-smart-panel])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-icon-button .ids-icon {
  vertical-align: middle;
}
.ids-icon-button.align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-icon-button.content-align-start {
  justify-content: start;
}
.ids-icon-button.content-align-end {
  justify-content: end;
}
.ids-icon-button.no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-icon-button.field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-icon-button ::slotted(span) {
  font-weight: inherit !important;
}
.ids-icon-button:not(.hide-focus).is-active:not([readonly]), .ids-icon-button:not(.hide-focus).is-focused:not([readonly]), .ids-icon-button:not(.hide-focus):focus:not([readonly]), .ids-icon-button:not(.hide-focus):focus-within:not([readonly]) {
  border-color: var(--ids-button-tertiary-color-border-focus);
}
.ids-icon-button:hover {
  color: var(--ids-button-tertiary-color-text-hover);
  background-color: var(--ids-button-tertiary-color-background-hover);
  border-color: var(--ids-button-tertiary-color-border-hover);
}
.ids-icon-button[disabled] {
  color: var(--ids-button-tertiary-color-text-disabled);
  background-color: var(--ids-button-tertiary-color-background-disabled);
  border-color: var(--ids-button-tertiary-color-border-disabled);
  opacity: var(--ids-button-tertiary-opacity-disabled);
}
.ids-icon-button:active:not([disabled]) {
  background-color: var(--ids-button-tertiary-color-background-pressed);
  border-color: var(--ids-button-tertiary-color-border-pressed);
  color: var(--ids-button-tertiary-color-text-pressed);
}
.ids-icon-button.btn-tertiary-destructive {
  background-color: var(--ids-button-destructive-tertiary-color-background-default);
  border-color: var(--ids-button-destructive-tertiary-color-border-default);
  color: var(--ids-button-destructive-tertiary-color-text-default);
}
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-tertiary-color-border-focus);
}
.ids-icon-button.btn-tertiary-destructive:hover {
  background-color: var(--ids-button-destructive-tertiary-color-background-hover);
  border-color: var(--ids-button-destructive-tertiary-color-border-hover);
  color: var(--ids-button-destructive-tertiary-color-text-hover);
}
.ids-icon-button.btn-tertiary-destructive[disabled] {
  color: var(--ids-button-destructive-tertiary-color-text-disabled);
  background-color: var(--ids-button-destructive-tertiary-color-background-disabled);
  border-color: var(--ids-button-destructive-tertiary-color-border-disabled);
}
.ids-icon-button.btn-primary {
  background-color: var(--ids-button-primary-color-background-default);
  border-color: var(--ids-button-primary-color-border-default);
  border: 1px solid var(--ids-button-primary-color-border-default);
  color: var(--ids-button-primary-color-text-default);
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
}
.ids-icon-button.btn-primary:not(.hide-focus).is-active, .ids-icon-button.btn-primary:not(.hide-focus).is-focused, .ids-icon-button.btn-primary:not(.hide-focus).focus-within, .ids-icon-button.btn-primary:not(.hide-focus):focus {
  border-color: var(--ids-button-primary-color-border-focus);
}
.ids-icon-button.btn-primary:hover {
  background-color: var(--ids-button-primary-color-background-hover);
  border-color: var(--ids-button-primary-color-border-hover);
}
.ids-icon-button.btn-primary[disabled] {
  background-color: var(--ids-button-primary-color-background-disabled);
  border-color: var(--ids-button-primary-color-border-disabled);
  color: var(--ids-button-primary-color-text-disabled);
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-icon-button.btn-primary:active:not([disabled]) {
  background-color: var(--ids-button-primary-color-background-pressed);
  border-color: var(--ids-button-primary-color-border-pressed);
  color: var(--ids-button-primary-color-text-pressed);
}
.ids-icon-button.btn-primary-destructive {
  background-color: var(--ids-button-destructive-color-background-default);
  border-color: var(--ids-button-destructive-color-border-default);
  color: var(--ids-button-destructive-color-text-default);
}
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-icon-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-icon-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-icon-button.btn-primary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-color-border-focus);
}
.ids-icon-button.btn-primary-destructive:hover {
  background-color: var(--ids-button-destructive-color-background-hover);
  border-color: var(--ids-button-destructive-color-border-hover);
  color: var(--ids-button-destructive-color-text-hover);
}
.ids-icon-button.btn-primary-destructive[disabled] {
  background-color: var(--ids-button-destructive-color-background-disabled);
  border-color: var(--ids-button-destructive-color-border-disabled);
  color: var(--ids-button-destructive-color-text-disabled);
  opacity: var(--ids-button-destructive-opacity-disabled);
}
@keyframes dot-flashing {
  0% {
    background-color: #fff;
  }
  50%, 100% {
    background-color: rgba(255 255 255/var(--ids-opacity-disabled));
  }
}
@keyframes dot-flashing-colors {
  0% {
    background-color: #0B9789;
  }
  50%, 100% {
    background-color: #1A3362;
  }
}
.ids-icon-button .loading-dots {
  display: none;
  position: relative;
  flex-direction: row;
  gap: 2px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
}
.ids-icon-button .loading-dots .dot {
  display: inline-flex;
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: var(--ids-button-ai-color-loading-dot-default);
  color: var(--ids-button-ai-color-loading-dot-default);
}
.ids-icon-button.btn-primary-generative-ai {
  background: border-box var(--ids-button-ai-color-background-default);
  color: #FFF;
  align-items: center;
  min-width: 34px;
  min-height: 34px;
}
.ids-icon-button.btn-primary-generative-ai:hover {
  background: border-box var(--ids-button-ai-color-background-hover);
  border-color: var(--ids-button-ai-color-border-hover);
}
.ids-icon-button.btn-primary-generative-ai:active, .ids-icon-button.btn-primary-generative-ai.gen-ai-active {
  background: border-box var(--ids-button-ai-color-background-active);
  color: var(--ids-button-ai-color-text-active);
}
.ids-icon-button.btn-primary-generative-ai[disabled] {
  background: border-box var(--ids-button-ai-color-background-disabled);
  border-color: var(--ids-button-ai-color-background-color-disabled);
}
.ids-icon-button.btn-primary-generative-ai.color-variant-alternate-formatter, .ids-icon-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover {
  color: #FFF;
  min-height: var(--ids-button-formatter-size);
  min-width: 34px;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-tertiary-generative-ai {
  background: var(--ids-button-ai-color-tertiary-background-default);
  background-clip: text;
  -webkit-text-fill-color: var(--ids-color-transparent);
  align-items: center;
}
.ids-icon-button.btn-tertiary-generative-ai:hover {
  background: var(--ids-button-ai-color-tertiary-background-hover);
  background-clip: text;
  border-color: var(--ids-color-transparent);
  -webkit-text-fill-color: var(--ids-color-transparent);
}
.ids-icon-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=insights-smart-panel]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);
}
.ids-icon-button.btn-tertiary-generative-ai:active .ids-icon-button.btn-tertiary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-color-background-active);
  background-clip: text;
  -webkit-text-fill-color: var(--ids-color-transparent);
}
.ids-icon-button.btn-tertiary-generative-ai[disabled] {
  background: var(--ids-button-tertiary-ai-color-background-disabled);
  background-clip: text;
  -webkit-text-fill-color: var(--ids-color-transparent);
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-icon-button.btn-tertiary-generative-ai[disabled] ::slotted(ids-icon[icon=insights-smart-panel]) {
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-secondary {
  background-color: var(--ids-button-secondary-color-background-default);
  border-width: var(--ids-button-secondary-border-width);
  border-color: var(--ids-button-secondary-color-border-default);
  color: var(--ids-button-secondary-color-text-default);
}
.ids-icon-button.btn-secondary:not(.hide-focus).is-active, .ids-icon-button.btn-secondary:not(.hide-focus).is-focused, .ids-icon-button.btn-secondary:not(.hide-focus).focus-within, .ids-icon-button.btn-secondary:not(.hide-focus):focus {
  background-color: var(--ids-button-secondary-color-background-focus);
  border-color: var(--ids-button-secondary-color-border-focus);
}
.ids-icon-button.btn-secondary:hover:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-hover);
  border-color: var(--ids-button-secondary-color-border-hover);
  color: var(--ids-button-secondary-color-text-hover);
}
.ids-icon-button.btn-secondary[disabled] {
  background-color: var(--ids-button-secondary-color-background-disabled);
  border-color: var(--ids-button-secondary-color-border-disabled);
  color: var(--ids-button-secondary-color-text-disabled);
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-icon-button.btn-secondary:active:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-pressed);
  border-color: var(--ids-button-secondary-color-border-pressed);
  color: var(--ids-button-secondary-color-text-pressed);
}
.ids-icon-button.color-variant-alternate:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.ids-icon-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover {
  background-color: var(--ids-search-field-header-color-icon-hover);
}
.ids-icon-button.color-variant-app-menu:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.ids-icon-button.color-variant-alternate, .ids-icon-button.color-variant-alternate-formatter {
  color: var(--ids-button-alternate-color-text-default);
  opacity: 0.8;
}
.ids-icon-button.color-variant-alternate:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate:not(.hide-focus):focus, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-button-formatter-color-border-focus);
  opacity: 1;
}
.ids-icon-button.color-variant-alternate:hover, .ids-icon-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-formatter-color-text-hover);
  opacity: 1;
}
.ids-icon-button.color-variant-alternate[disabled], .ids-icon-button.color-variant-alternate-formatter[disabled] {
  background-color: var(--ids-color-transparent);
  opacity: var(--ids-button-formatter-opacity-disabled);
}
.ids-icon-button.color-variant-alternate-formatter {
  background-color: var(--ids-button-formatter-color-background-default);
  border-color: var(--ids-button-formatter-color-border-default);
  color: var(--ids-button-formatter-color-text-default);
  margin-top: 2px;
  height: var(--ids-button-formatter-size);
  min-width: var(--ids-button-formatter-size);
}
.ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-color-border-focus);
}
.ids-icon-button.color-variant-alternate-formatter[disabled] {
  color: var(--ids-button-formatter-color-text-disabled);
}
.ids-icon-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  color: var(--ids-button-formatter-color-text-hover);
}
.ids-icon-button.color-variant-alternate-formatter.is-active {
  color: var(--ids-button-formatter-color-active);
}
.ids-icon-button.color-variant-alternate-formatter.ids-menu-button.compact {
  padding: var(--ids-space-2xs);
  padding-inline: var(--ids-space-2xs);
}
.ids-icon-button.color-variant-alternate-formatter.ids-menu-button.compact.square {
  border-radius: var(--ids-border-radius-xs);
}
.ids-icon-button.color-variant-alternate-formatter[editor-action=sourcemode], .ids-icon-button.color-variant-alternate-formatter[editor-action=editormode] {
  --ids-button-icon-width: 54px;
}
.ids-icon-button.color-variant-module {
  color: var(--ids-button-module-color-text-default);
}
.ids-icon-button.color-variant-module:not(.square) {
  border-radius: var(--ids-button-module-border-radius);
}
.ids-icon-button.color-variant-module:hover {
  background-color: var(--ids-button-module-color-background-hover);
  color: var(--ids-button-module-color-text-hover);
}
.ids-icon-button:not(.no-padding) {
  padding-inline-start: var(--ids-button-icon-padding);
  padding-inline-end: var(--ids-button-icon-padding);
  padding-top: var(--ids-button-icon-padding);
  padding-bottom: var(--ids-button-icon-padding);
}
.ids-icon-button:not(.no-padding):not(.ids-trigger-button) {
  height: var(--ids-button-icon-height);
  width: var(--ids-button-icon-width);
}
.ids-icon-button:not(.square) {
  border-radius: var(--ids-button-radius);
}
.ids-icon-button.square {
  border-radius: var(--ids-border-radius-none);
}
.ids-icon-button .ids-icon:not(.dropdown-icon) {
  display: block;
  padding-inline-start: var(--ids-space-3xs);
  font-size: 0;
  padding-block-start: var(--ids-space-3xs);
}
.ids-icon-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-icon-button.no-margins {
  margin-inline-start: var(--ids-space-none);
  margin-inline-end: var(--ids-space-none);
}

.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]) {
  box-shadow: var(--ids-button-tertiary-shadow-focus);
}
.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus {
  box-shadow: var(--ids-box-shadow-inverse);
}
.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus {
  box-shadow: var(--ids-shadow-20);
}
.ids-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus):focus {
  box-shadow: var(--ids-button-destructive-tertiary-shadow-focus);
}
.ids-button.btn-primary:not(.hide-focus).is-active, .ids-button.btn-primary:not(.hide-focus).is-focused, .ids-button.btn-primary:not(.hide-focus).focus-within, .ids-button.btn-primary:not(.hide-focus):focus,
.ids-icon-button.btn-primary:not(.hide-focus).is-active,
.ids-icon-button.btn-primary:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary:not(.hide-focus):focus,
.ids-menu-button.btn-primary:not(.hide-focus).is-active,
.ids-menu-button.btn-primary:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary:not(.hide-focus):focus {
  box-shadow: var(--ids-button-primary-shadow-focus);
}
.ids-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus):focus,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus):focus {
  box-shadow: 0 0 0 2px var(--ids-color-primary-70), 0 0 0 3px var(--ids-color-text-on-primary);
}
.ids-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-destructive:not(.hide-focus):focus {
  box-shadow: 0 0 0 2px var(--ids-color-background-default), 0 0 0 3px var(--ids-color-error-default);
}
.ids-button.btn-secondary:not(.hide-focus).is-active, .ids-button.btn-secondary:not(.hide-focus).is-focused, .ids-button.btn-secondary:not(.hide-focus).focus-within, .ids-button.btn-secondary:not(.hide-focus):focus,
.ids-icon-button.btn-secondary:not(.hide-focus).is-active,
.ids-icon-button.btn-secondary:not(.hide-focus).is-focused,
.ids-icon-button.btn-secondary:not(.hide-focus).focus-within,
.ids-icon-button.btn-secondary:not(.hide-focus):focus,
.ids-menu-button.btn-secondary:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary:not(.hide-focus):focus {
  box-shadow: var(--ids-button-secondary-shadow-focus);
}
.ids-button.btn-primary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-primary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-primary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-primary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus):focus {
  box-shadow: var(--ids-button-ai-shadow-focus);
  border-color: var(--ids-color-transparent);
}
.ids-button.btn-tertiary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-tertiary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus):focus {
  box-shadow: var(--ids-button-tertiary-ai-shadow-focus);
  border-color: var(--ids-button-ai-color-icon-secondary-hover);
}

.ids-modal-button:not(.ids-modal-icon-button) {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
  padding-block-start: var(--ids-space-12);
  padding-block-end: var(--ids-space-12);
  display: block;
  font-weight: var(--ids-font-weight-strong);
  justify-content: center;
  height: 100%;
  width: 100%;
}
.ids-modal-button:not(.ids-modal-icon-button), .ids-modal-button:not(.ids-modal-icon-button)::before, .ids-modal-button:not(.ids-modal-icon-button)::after {
  box-sizing: border-box;
}
.ids-modal-button:not(.ids-modal-icon-button) * {
  pointer-events: none;
}
.ids-modal-button:not(.ids-modal-icon-button):focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-modal-button:not(.ids-modal-icon-button):not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-modal-button:not(.ids-modal-icon-button) span {
  vertical-align: bottom;
}
.ids-modal-button:not(.ids-modal-icon-button) span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-modal-button:not(.ids-modal-icon-button):not(.ids-icon-button):not(.align-icon-end) ::slotted(ids-icon:not([icon=insights-smart-panel])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-modal-button:not(.ids-modal-icon-button) .ids-icon {
  vertical-align: middle;
}
.ids-modal-button:not(.ids-modal-icon-button).align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-modal-button:not(.ids-modal-icon-button).content-align-start {
  justify-content: start;
}
.ids-modal-button:not(.ids-modal-icon-button).content-align-end {
  justify-content: end;
}
.ids-modal-button:not(.ids-modal-icon-button).no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-modal-button:not(.ids-modal-icon-button).field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-modal-button:not(.ids-modal-icon-button) ::slotted(span) {
  font-weight: inherit !important;
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary {
  background-color: var(--ids-modal-color-background);
  color: var(--ids-modal-button-color-default);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus):focus {
  box-shadow: var(--ids-modal-shadow-focus);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary:hover {
  color: var(--ids-modal-button-color-hover);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary[disabled] {
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary {
  background-color: var(--ids-modal-color-background);
  color: var(--ids-modal-button-secondary-color-default);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus):focus, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus):focus {
  box-shadow: var(--ids-modal-shadow-focus);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary:hover, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:hover {
  color: var(--ids-modal-button-secondary-color-hover);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary[disabled], .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary[disabled] {
  background-color: var(--ids-button-secondary-color-border-disabled);
  border-color: var(--ids-button-secondary-color-border-disabled);
}
.ids-modal-button:not(.ids-modal-icon-button):focus {
  z-index: 1;
}

.ids-modal-icon-button {
  padding: var(--ids-space-xs);
}

.btn-swipe-action-left,
.btn-swipe-action-right {
  display: block;
  padding: 0 var(--ids-space-xs) var(--ids-space-xs);
  height: 100%;
  margin: 0;
  white-space: inherit;
  width: 85px;
}
.btn-swipe-action-left ::slotted(ids-icon),
.btn-swipe-action-right ::slotted(ids-icon) {
  display: block;
}
.btn-swipe-action-left:hover, .btn-swipe-action-left:focus,
.btn-swipe-action-right:hover,
.btn-swipe-action-right:focus {
  box-shadow: none;
  border-color: var(--ids-color-transparent);
}

.ids-button:not(.no-margins).btn-swipe-action-left,
.ids-button:not(.no-margins).btn-swipe-action-right {
  margin: 0;
}

.btn-swipe-action-left {
  border-start-end-radius: var(--ids-border-radius-none);
  border-end-end-radius: var(--ids-border-radius-none);
  background-color: var(--ids-swipe-action-color-background-left);
  color: var(--ids-swipe-action-color-text-left);
}
.btn-swipe-action-left:active {
  background-color: var(--ids-swipe-action-color-background-left-active);
  color: var(--ids-swipe-action-color-text-left-active);
}
.btn-swipe-action-left:hover {
  background-color: var(--ids-swipe-action-color-background-left-hover);
  color: var(--ids-swipe-action-color-text-left-hover);
}

.btn-swipe-action-right {
  border-start-start-radius: var(--ids-border-radius-none);
  border-end-start-radius: var(--ids-border-radius-none);
  background-color: var(--ids-swipe-action-color-background-right);
  color: var(--ids-swipe-action-color-text-right);
}
.btn-swipe-action-right:active {
  background-color: var(--ids-swipe-action-color-background-right-active);
  color: var(--ids-swipe-action-color-text-right-active);
}
.btn-swipe-action-right:hover {
  background-color: var(--ids-swipe-action-color-background-right-hover);
  color: var(--ids-swipe-action-color-text-right-hover);
}

.ids-icon-button.gen-ai-active:not(.no-animation) ::slotted(ids-icon[icon=insights-smart-panel]),
.ids-button.gen-ai-active:not(.no-animation) ::slotted(ids-icon[icon=insights-smart-panel]) {
  display: none;
}
.ids-icon-button.gen-ai-active:not(.no-animation) .loading-dots,
.ids-button.gen-ai-active:not(.no-animation) .loading-dots {
  display: flex;
}

.ids-icon-button.gen-ai-active .loading-dots {
  padding-inline-start: 3px;
  padding-inline-end: var(--ids-space-3xs);
  padding-block-start: 7px;
  padding-block-end: var(--ids-space-xs);
}

.ids-button ::slotted(ids-icon:not(:first-child)),
.ids-toggle-button ::slotted(ids-icon:not(:first-child)),
.ids-menu-button:not(.ids-icon-button) ::slotted(ids-icon:not(:first-child)),
.ids-modal-button:not(.ids-icon-button) ::slotted(ids-icon:not(:first-child)) {
  margin-inline-start: 5px;
  margin-inline-end: var(--ids-space-none);
}
.ids-button .ids-icon:last-child,
.ids-button span + span:not(.audible),
.ids-button span:not(.audible):last-child,
.ids-toggle-button .ids-icon:last-child,
.ids-toggle-button span + span:not(.audible),
.ids-toggle-button span:not(.audible):last-child,
.ids-menu-button:not(.ids-icon-button) .ids-icon:last-child,
.ids-menu-button:not(.ids-icon-button) span + span:not(.audible),
.ids-menu-button:not(.ids-icon-button) span:not(.audible):last-child,
.ids-modal-button:not(.ids-icon-button) .ids-icon:last-child,
.ids-modal-button:not(.ids-icon-button) span + span:not(.audible),
.ids-modal-button:not(.ids-icon-button) span:not(.audible):last-child {
  padding-inline-start: 5px;
}

.ids-modal-button ::slotted(ids-icon:not(:first-child)) {
  padding: var(--ids-space-3xs);
}

:host(:not([show-loading-indicator=true])) ::slotted(.slot-loading-indicator) {
  display: none;
}

:host([show-loading-indicator=true]) ::slotted(ids-loading-indicator) {
  margin-top: 3px;
  margin-bottom: 3px;
}

:host([show-loading-indicator=true][loading-indicator-only=true]) ::slotted(*:not(.slot-loading-indicator)) {
  visibility: hidden;
}

:host([show-loading-indicator=true]:not([loading-indicator-only=true])) ::slotted(.slot-loading-indicator) {
  margin-inline-start: 6px;
}

:host([show-loading-indicator=true]:not([loading-indicator-only=true]):is([appearance=primary], [appearance=secondary], [appearance=primary-destructive]))::part(button) {
  padding-inline-start: 20px;
  padding-inline-end: 12px;
}
:host([show-loading-indicator=true]:not([loading-indicator-only=true]):is([appearance=primary], [appearance=secondary], [appearance=primary-destructive])) ::slotted(.slot-loading-indicator) {
  margin-inline-start: 10px;
}

:host([loading-indicator-only=true]) ::slotted(.slot-loading-indicator) {
  position: absolute;
  margin-inline-start: auto;
  margin-inline-end: auto;
  left: var(--ids-space-none);
  right: var(--ids-space-none);
}

:host(ids-toggle-button) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-default);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-default);
}

:host(ids-toggle-button[pressed]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-default);
}

:host(ids-toggle-button[color=orange]) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-orange);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-orange);
}

:host(ids-toggle-button[pressed][color=orange]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-orange);
}

:host(ids-toggle-button[color=red]) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-red);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-red);
}

:host(ids-toggle-button[pressed][color=red]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-red);
}

:host(ids-toggle-button.ids-toggle-button-segmented) button {
  border-radius: var(--ids-border-radius-circle);
}
:host(ids-toggle-button.ids-toggle-button-segmented) button:hover {
  color: var(--ids-segmented-control-text-color);
  background-color: var(--ids-segmented-control-background-hover);
}

:host(ids-toggle-button.ids-toggle-button-segmented[pressed]) button {
  color: var(--ids-segmented-control-text-color);
  background-color: var(--ids-segmented-control-background-hover);
  box-shadow: var(--ids-segmented-control-box-shadow);
  border-color: transparent;
}`;var U=O(C(P(S(L(T(N)))))),e,q,p,G,M,R,u=class extends U{constructor(){super();k(this,e);g(this,"shouldUpdate",!1);g(this,"colorVariants",["alternate","alternate-formatter","module","module-nav"]);Object.keys(m).forEach(t=>{this.state[t]=m[t]}),Object.defineProperty(this,"tabIndex",{get:()=>x(this,e,M),set:t=>{w(this,e,t,G)},configurable:!0,enumerable:!0}),this.refreshProtoClasses()}connectedCallback(){super.connectedCallback(),c(this,e,p).call(this),this.shouldUpdate=!0,this.getAttribute("width")&&(this.width=this.getAttribute("width")),this.cssClass=this.cssClass,c(this,e,q).call(this),requestAnimationFrame(()=>{this.refreshProtoClasses()})}mountedCallback(){this.refreshProtoClasses()}toggleAnimation(t){if(!this.appearance.includes("generative-ai"))return;let i=this.button?.classList.contains("gen-ai-active");this.button?.classList.toggle("gen-ai-active",typeof t=="boolean"?t:!i)}static get attributes(){return[...super.attributes,...B]}get protoClasses(){let t=this.querySelector("span:not(.audible), ids-text:not([audible])");return this.iconEl&&!t?["ids-icon-button"]:["ids-button"]}refreshProtoClasses(){if(!this.button)return;let t=this.button.classList,i=this.protoClasses;t.remove(...D),t.add(...i)}template(){let t="",i="",n="",r='tabindex="0"',s="";this.state?.cssClass&&(t=` ${this.state.cssClass.join(" ")}`),this.state?.disabled&&(n=' disabled="true"'),this.state?.tabIndex&&(r=`tabindex="${this.state.tabIndex}"`),this.state&&this.state?.appearance!=="default"&&this.state.appearance!==void 0&&(s=` btn-${this.state.appearance}`),this.hasAttribute(o.SQUARE)&&(t+=" square"),this.hasAttribute(o.NO_PADDING)&&(t+=" no-padding"),this.protoClasses.length&&(i=`${this.protoClasses.join(" ")}`);let b="";return this.state?.iconAlign&&(b=` align-icon-${this.state?.iconAlign}`),`<button part="button" type="${this.type}" class="${i}${s}${b}${t}" ${r}${n}>
      <slot></slot>
      <slot name="loading-indicator"></slot>
    </button>`}onHiddenChange(t){let i=a(t);this.shouldUpdate=!1,i?this.setAttribute(o.HIDDEN,""):this.removeAttribute(o.HIDDEN),this.shouldUpdate=!0,this.state.hidden=i,this.button&&(this.button.hidden=i)}setAriaText(){this.container&&this.container.setAttribute(A.ARIA_LABEL,this.text?.trim()||"Button")}get button(){return this.shadowRoot?.querySelector("button")||null}set contentAlign(t){!t||v.indexOf(t)<=0?(this.removeAttribute(o.CONTENT_ALIGN),this.state.contentAlign=v[0]):(this.setAttribute(o.CONTENT_ALIGN,t),this.state.contentAlign!==t&&(this.state.contentAlign=t)),this.setContentAlignClass(t)}get contentAlign(){return this.state.appearance}setContentAlignClass(t){this.button&&v.forEach(i=>{let n=`content-align-${i}`;if(t===i){i!=="default"&&!this.button?.classList.contains(n)&&this.button?.classList.add(n);return}this.button?.classList.contains(n)&&this.button?.classList.remove(n)})}set cssClass(t){let i=t,n=[],r=[].concat(this.state.cssClass);if(Array.isArray(t)?(n=t,i=t.join(" ")):typeof t=="string"&&t.length&&(n=t.split(" ")),this.state.cssClass=n,n.length?this.setAttribute(o.CSS_CLASS,i.toString()):this.removeAttribute(o.CSS_CLASS),!this.button)return;let s=this.button.classList,b=Array.from(s);r.forEach(d=>{n.includes(d)||s.remove(d)}),n.forEach(d=>{b.includes(d)||s.add(d)})}get cssClass(){return this.state.cssClass}set disabled(t){let i=a(t);this.shouldUpdate=!1,i?this.setAttribute(o.DISABLED,""):this.removeAttribute(o.DISABLED),this.shouldUpdate=!0,this.state.disabled=i,this.button&&(this.button.disabled=i)}get disabled(){return this.state.disabled}set icon(t){if(typeof t!="string"||!t.length){this.removeAttribute(o.ICON),this.state.icon=void 0,this.removeIcon();return}this.state.icon=t,this.setAttribute(o.ICON,t),this.appendIcon(t)}get icon(){return this.iconEl?.getAttribute("icon")}get iconEl(){return this.querySelector("ids-icon")}set iconAlign(t){f.includes(`align-icon-${t}`)||(t=void 0),this.state.iconAlign=t,this.setIconAlignment()}get iconAlign(){return this.state?.iconAlign}get width(){return this.getAttribute(o.WIDTH)}set width(t){if(!t){this.removeAttribute(o.WIDTH),this.style.width="",this.button&&(this.button.style.width="");return}t.indexOf("%")!==-1?(this.style.width=t,this.button&&(this.button.style.width="")):(this.style.width="",this.button&&(this.button.style.width=t)),this.setAttribute(o.WIDTH,t)}set noAnimation(t){let i=a(t);this.toggleAttribute(o.NO_ANIMATION,i),this.container?.classList.toggle(o.NO_ANIMATION,i)}get noAnimation(){return this.hasAttribute(o.NO_ANIMATION)}appendIcon(t){let i=this.querySelector("ids-icon"),n=this.iconAlign,r=n==="end"?"beforeend":"afterbegin";i?(i.icon!==t&&(i.icon=t,this.setIconAlignment()),n==="end"&&this.hasIncorrectEndElement()?this.append(i):this.hasIncorrectStartElement()&&this.prepend(i)):this.insertAdjacentHTML(r,`<ids-icon icon="${t}" class="ids-icon"></ids-icon>`),this.refreshProtoClasses()}removeIcon(){let t=this.querySelector("ids-icon");t&&t.remove(),this.setIconAlignment(),this.refreshProtoClasses()}setIconAlignment(){if(!this.button)return;let t=this.iconAlign,i=this.icon;if(this.button.classList.remove(...f),t&&i){this.button.classList.add(`align-icon-${t}`);let n=this.hasIncorrectStartElement(),r=this.hasIncorrectEndElement();(n||r)&&this.appendIcon(i)}}hasIncorrectStartElement(){return this.iconAlign==="start"&&!this.children[0].isEqualNode(this.iconEl)}hasIncorrectEndElement(){return this.iconAlign==="end"&&!this.children[this.children.length-1].isEqualNode(this.iconEl)}set text(t){if(this.removeAttribute(o.TEXT),typeof t!="string"||!t.length){this.state.text="",this.removeText();return}this.state.text=t,this.appendText(t)}get text(){let t=this.querySelector("span:not(.audible)");return t&&t.textContent?.length?t.textContent:this.textContent}appendText(t){let i=this.querySelector("span:not(.audible)"),n=this.iconAlign,r=n==="end"?"afterbegin":"beforeend";i?(i.textContent=t,this.setAriaText(),n==="end"&&this.hasIncorrectEndElement()?this.prepend(i):n==="start"&&this.hasIncorrectStartElement()&&this.append(i)):this.insertAdjacentHTML(r,`<span>${t}</span>`),this.refreshProtoClasses()}removeText(){let t=this.querySelector("span:not(.audible)");t&&t.remove(),this.refreshProtoClasses()}set appearance(t){!t||l.indexOf(t)<=0?(this.state.appearance=l[0],this.removeAttribute(o.APPEARANCE)):(this.state.appearance=t,this.setAttribute(o.APPEARANCE,t)),this.setAppearanceClass(t)}get appearance(){return this.state.appearance}set type(t){t&&h.includes(t)?(this.setAttribute(o.TYPE,t),this.button?.setAttribute(o.TYPE,t),this.state.type!==t&&(this.state.type=t)):(this.removeAttribute(o.TYPE),this.button?.removeAttribute(o.TYPE),this.state.type=h[0])}get type(){return this.state.type||"button"}set noMargins(t){if(a(t)){this.setAttribute(o.NO_MARGINS,""),this.container?.classList.add(o.NO_MARGINS);return}this.removeAttribute(o.NO_MARGINS),this.container?.classList.remove(o.NO_MARGINS)}get noMargins(){return a(this.getAttribute(o.NO_MARGINS))}set noPadding(t){let i=this.noPadding,n=a(t);i!==n&&(n?(this.container?.classList.add(o.NO_PADDING),this.setAttribute(o.NO_PADDING,"true")):(this.container?.classList.remove(o.NO_PADDING),this.removeAttribute(o.NO_PADDING)))}get noPadding(){return a(this.getAttribute(o.NO_PADDING))}set square(t){let i=a(t);this.button&&(i&&!this.button.classList.contains("square")?this.button.classList.add("square"):!i&&this.button.classList.contains("square")&&this.button.classList.remove("square")),i&&!this.hasAttribute(o.SQUARE)?this.setAttribute(o.SQUARE,""):!i&&this.hasAttribute(o.SQUARE)&&this.removeAttribute(o.SQUARE)}get square(){return this.hasAttribute(o.SQUARE)}setAppearanceClass(t){this.button&&(l.forEach(i=>{let n=`btn-${i}`;if(t===i){i!=="default"&&!this.button?.classList.contains(n)&&this.button?.classList.add(n);return}this.button?.classList.contains(n)&&this.button?.classList.remove(n)}),this.button?.classList.remove("btn-undefined"))}focus(){this.button?.focus()}onColorVariantRefresh(){let t=this.querySelectorAll("ids-icon"),i=this.querySelectorAll("ids-text, span"),n=r=>{r instanceof HTMLSpanElement||(r.colorVariant=this.colorVariant)};[...t,...i].forEach(n)}set badgeColor(t){t?(this.setAttribute(o.BADGE_COLOR,t),this.iconEl?.setAttribute(o.BADGE_COLOR,t)):(this.removeAttribute(o.BADGE_COLOR),this.iconEl?.removeAttribute(o.BADGE_COLOR))}get badgeColor(){return this.iconEl?.getAttribute(o.BADGE_COLOR)}get badgePosition(){return this.iconEl?.getAttribute(o.BADGE_POSITION)}set badgePosition(t){t?(this.setAttribute(o.BADGE_POSITION,t),this.iconEl?.setAttribute(o.BADGE_POSITION,t)):(this.removeAttribute(o.BADGE_POSITION),this.iconEl?.removeAttribute(o.BADGE_POSITION))}};e=new WeakSet,q=function(){this.offEvent("click",this.container),this.onEvent("click",this.container,()=>{this.toggleAnimation()})},p=function(){this.hasAttribute(o.ICON)&&this.appendIcon(this.getAttribute(o.ICON)),this.hasAttribute(o.TEXT)&&this.appendText(this.getAttribute(o.TEXT)),this.setAriaText(),this.hasAttribute(o.CONTENT_ALIGN)&&this.setContentAlignClass(this.getAttribute(o.CONTENT_ALIGN)),this.setIconAlignment(),this.refreshProtoClasses(),this.localeAPI.updateDirectionAttribute(this,this.localeAPI.language.name),c(this,e,R).call(this,this.appearance)},G=function(t){let i=Number(t);if(this.removeAttribute(o.TABINDEX),Number.isNaN(i)||i<-1){this.state.tabIndex=0,this.button?.setAttribute(o.TABINDEX,"0");return}this.state.tabIndex=i,this.button?.setAttribute(o.TABINDEX,`${i}`)},M=function(){return this.state.tabIndex},R=function(t){if(!t.includes("generative")||this.querySelector('ids-icon[icon="insights-smart-panel"]'))return;let i=`<defs>
      <linearGradient id="paint-linear" x1="14.6681" y1="-32.5625" x2="31.7256" y2="-26.8896" gradientUnits="userSpaceOnUse">
        <stop offset="0.117757" class="insights-stop-1"></stop>
        <stop offset="0.927091" class="insights-stop-2"></stop>
      </linearGradient>
    </defs>`,n=`<div class="loading-dots">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>`,r=document.createElement("ids-icon");r.setAttribute("icon","insights-smart-panel"),this.append(r),this.container?.insertAdjacentHTML("beforeend",n),c(this,e,p).call(this),t.includes("tertiary")&&requestAnimationFrame(()=>{r.appendSVGDefs?.(i),r.pathElem?.setAttribute("fill","url(#paint-linear)")})},u=y([I("ids-button"),E(_)],u);export{_ as a,u as b};
